$(document).ready(initPage);

function initPage() {
  function checkScroll() {
    if ($(window).scrollTop() > 0) {
      $('body').addClass('is-scrolled');
    } else {
      $('body').removeClass('is-scrolled');
    }
  }
  checkScroll();
  $(window).scroll(function () {
    checkScroll();
  });
  $('.header-toggler').click(function () {
    $('body').toggleClass('is-menu');
  });

  $('.header-menu li.menu-item-has-children').hover(
    function () {
      $(this).addClass('is-expanded');
      clearTimeout($(this).data('timeout'));
    },
    function () {
      const element = $(this);
      const timeout = setTimeout(function () {
        element.removeClass('is-expanded');
      }, 400);
      element.data('timeout', timeout);
    }
  );
  $('.header-menu li.menu-item-has-children > span').click(function () {
    $(this).parent().toggleClass('is-expanded-mobile');
  });

  $('.appointment-toggler').click(function () {
    $('.section-appointment').toggleClass('is-expanded');
  });

  var customersSwiper = new Swiper('.swiper--customers', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 2,
      },
      1025: {
        slidesPerView: 3,
      },
    },
    navigation: {
      prevEl: '.section-customers .swiper-prev',
      nextEl: '.section-customers .swiper-next',
    },
    on: {
      init: function () {
        this.slides.forEach((slide) => {
          const realIndex = slide.getAttribute('data-swiper-slide-index');
          if (realIndex % 3 === 1) {
            slide.classList.add('is-green');
          }
          if (realIndex % 3 === 2) {
            slide.classList.add('is-blue');
          }
        });
      },
    },
  });

  /*** video ***/

  $('.video-preview').click(function () {
    $(this).parent().addClass('is-active');
    const iframe = $(this).parent().find('iframe')[0];

    iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  });
}
